module.exports = __webpack_public_path__ + "static/media/en_GB.2c642f07.png";